import React from 'react'
import * as api from '../../api';
import * as qs from "query-string";
import { toast } from 'react-toastify';
import { FilePond } from 'react-filepond';
import { AuthService } from '../../services/auth-service'
import { apiUrl } from "../../config.js"
import DatePicker from "react-datepicker"
import { withRouter } from "react-router-dom";
import { Grid, Header, Segment, Popup, Button, Input, Modal, Select, Dimmer, Loader, Checkbox,Message,Icon,Dropdown  } from 'semantic-ui-react';
import HelpSection from '../about/HelpSection';

const authService = new AuthService();


class AddSiteModel extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            uploadStatusList: ["error1", "error2"],
            meterModalOpen: false,
            submittingInProgress: false,
            showErrorHide: true,
            showSuccessHide: true,
            allowSubmit : true,
            siteAddress: '',
            meterAddress: '',
            newBillingAddress: '',
            previousOccupierName: '',
            previousOccupierContact: '',

            billingOptions:"",
            isCheckboxChecked: false,
            entityEstateCode : '',

            changeDate: '',
            params: qs.parse(this.props.location.search),
            utility: '',
            mpanmpr: '',
            meterserial: '',
            supplierName: '',
            openingMeterReads: '',
            meters: [
                // { id : 1, utility : 'hello', mpanmpr : 'yeah', supplierName : 'france', openingmeterreads : '888' },
                // { id : 2, utility : 'hello2', mpanmpr : 'yeah3', supplierName : 'france4', openingmeterreads : '8882' }
            ],
            fileList: [],
            customerId: authService.getUserData(AuthService.CUSTOMER_ID_KEY),
            metersList: [],
            prevFileList: [],
            cotsAccess : authService.getUserData(AuthService.COTSACCESS)
        }

    }

    componentDidMount = () => {

       
        this.fetchData().then( () =>
        {
            if(this.state.params.queue !== undefined)
            {

               return Promise.all([
                api.GetLogNewSite(this.state.params.queue),
             ])
              .then(([cotDetails])=> {


                this.setOpen(true)


                



               var fileListTemp =  JSON.parse(cotDetails.fileString)


               fileListTemp.forEach(function(part, index, theArray) {
                    theArray[index] =  theArray[index].substring(theArray[index].lastIndexOf('\\')+1);
                 });

            

              var parts = cotDetails.changeDate.split("/");
              var dt = new Date(parseInt(parts[2], 10),
                                parseInt(parts[1], 10) - 1,
                                parseInt(parts[0], 10));


              this.setState({
                siteAddress : cotDetails.siteAddress,
                meterAddress : (cotDetails.meterAddress !== null ? cotDetails.meterAddress : ""),
                actualChangeDate : cotDetails.changeDate,
                changeDate : dt,
                billingOptions : 'otherBilling',
                newBillingAddress : (cotDetails.newBillingAddress !== null ? cotDetails.newBillingAddress : ""),
                previousOccupierName : (cotDetails.previousOccupierName !== null ? cotDetails.previousOccupierName : ""),
                previousOccupierContact : (cotDetails.previousOccupierContact !== null ? cotDetails.previousOccupierContact : ""),
                meters :  JSON.parse(cotDetails.metersString),
                prevFileList :  JSON.parse(cotDetails.fileString),
                prevFileNames : fileListTemp








              })
            });
            }
        });

       
  
       
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.state.isCheckboxChecked && this.state.siteAddress !== prevState.siteAddress) {
            this.setState({
                meterAddress: this.state.siteAddress
            });
        }
    }
    

    fetchData = () => {
        return Promise.all([
            api.getMetersList(this.state.customerId),
         ])
          .then(([metersList])=> {
          this.setState({metersList : metersList
          })
         
        });
    };

    setOpen = (open) => {
        if (open === false) {
            this.setState({
                showInfoHide: false,
                showErrorHide: true,
                showSuccessHide: true,
                showSiteDocsWarning : false,
                meterModalOpen: false
            });
        }
        this.setState({
            meterModalOpen: open
        });
    }

    setOpenClearHistory = (id,queue) => {
        this.setState({
            showInfoHide: false,
            showErrorHide: true,
            showSuccessHide: true,
            showSiteDocsWarning: false,
            meterModalOpen: false
        });
        this.props.history.push("/cotqueue?qid=" + id + "&queue=" + queue);
        //window.location.reload();
    }

    handleChange = event => {


        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleDropDownChange = (event, data) => {

       
        this.setState({
            [data.name]: data.value
        });

    }

    handleDateChange = (newDate) => {

      

        this.setState({ changeDate: newDate,
                    actualChangeDate: newDate.toLocaleDateString('en-GB')});

    };

    fromDateChanged = (newDate) => {
    }

    onFilesUpdated = (fileItems) => {
        this.setState({
            files: fileItems.map(fileItem => fileItem.file)
        });

    };

    handleRemoveMeter = (name, value) => {

     

        let myArr = [...this.state.meters]

        let filtereedArray = myArr.filter(({ id }) => id !== value.id);

        this.setState({
            meters: filtereedArray
        })
    };

    handleChangeChk = () => {
        this.setState({allowSubmit:!this.state.allowSubmit})  
    }

    notify = (message, error = false, refresh = false) => {
        if (error) {
            toast.error(message, {
                position: toast.POSITION.TOP_CENTER,
                delay: 50,
                autoClose: false
            });
        }else if (refresh){
            toast.success(message, {
                position: toast.POSITION.TOP_CENTER,
               autoClose: false,
               onClose: () => {
                this.props.history.push("/");
                window.location.reload();
               }
            });
        } else {
            toast.success(message, {
                position: toast.POSITION.TOP_CENTER,
               autoClose: false,
               closeOnClick: false
            });
        }
    }

    handleCopyAddress = () => {
        this.setState(prevState => ({
            meterAddress:this.state.siteAddress,
            isCheckboxChecked: !prevState.isCheckboxChecked
        }));    }

     isAlphaNumeric(str) {
        // Use a regular expression to check if the string contains only letters and numbers
        return /^[a-z0-9]+$/i.test(str);
      }

      isValidMPANCore(mpan) {
      
        var numberRegex = /^(1[0-9]|2[0-7])\d{11}$/; //Core
        return numberRegex.test(mpan);
    
}

validateSupplier(str)
{
    if (str.length < 5) {
        return "String must be at least 5 characters in length.";
    }
    if (str === "TBC" || str === "Unknown" || str === "N/A" || str === "Don't Know" || str === "....."|| str === "?????") {
        return "Invalid input, Please provide a valid answer.";
    }
    return "Valid";
}



    handleAddMeter = (name, value) => {

       
        if (
            !(this.state.utility.length > 0 && 
            (this.state.customerId === "4799" || this.state.mpanmpr.length > 0) &&
            (this.state.customerId === "4799" || this.state.supplierName.length > 0) && 
            this.state.openingMeterReads.length > 0 && 
            this.state.meterserial.length > 0)
        ) {
            toast.error('Please enter all meter details before submission', {
                position: toast.POSITION.TOP_CENTER,
                delay: 100
            });
        }else if(this.state.customerId !== "4799" && this.validateSupplier(this.state.supplierName) !== "Valid")
            {
                toast.error('Please check supplier details ' +  this.validateSupplier(this.state.supplierName), {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50
                });
            }
            else 
        {


            if( this.state.customerId === "4799" || (this.state.utility === "elec" && this.state.mpanmpr.length === 13 && this.isValidMPANCore(this.state.mpanmpr)))
            {
                    //Va;id
            }else if(this.state.utility === "elec" && this.state.mpanmpr.length === 13 && !this.isValidMPANCore(this.state.mpanmpr))
            {
                toast.error('The MPAN/MPR is invalid - Core must be 13 digits starting from 10 to 38', {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50
                });
    
                return;
            }else if(this.state.utility === "elec")
             {
            let lvErrorMessage = "";

            if (this.state.mpanmpr.length <= 13) {
                lvErrorMessage = "Too Short.";

                toast.error('The MPAN/MPR is invalid -' + lvErrorMessage, {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50
                });
    
                return;
                }
                    if (this.state.mpanmpr.charCodeAt(0) !== 83) {
                    lvErrorMessage = "SNUM must begin with a letter 'S'.";
                    }

                    if (this.state.mpanmpr.length !== 22) {
                    lvErrorMessage = "SNUM must be 22 characters in length.";
                    }

                    if (parseInt(this.state.mpanmpr.substring(1, 3)) > 8) {
                    lvErrorMessage = "Profile must be between the range '00 - 08'.";
                    }

                    if (parseInt(this.state.mpanmpr.substring(1, 6)) === 0) {
                    lvErrorMessage = "Invalid number range from characters 2 - 7.";
                    }


                    if(lvErrorMessage !== "")
                    {
                    toast.error('The MPAN/MPR is invalid -' + lvErrorMessage, {
                        position: toast.POSITION.TOP_CENTER,
                        delay: 50
                    });
        
                    return;
                }


        }else if(!this.isAlphaNumeric(this.state.mpanmpr))
        {
            toast.error('The MPAN/MPR must only contain letters or numbers please check the data entered.', {
                position: toast.POSITION.TOP_CENTER,
                delay: 100
            });

            return;
        }
        



            let filtereedArray = this.state.metersList.filter(meter => meter.serialNumber === this.state.mpanmpr);

        if(filtereedArray.length > 0)
        {

            toast.error('Looks like we already have this meter active against your account. Plese verify before continuing', {
                position: toast.POSITION.TOP_CENTER,
                delay: 100
            });

            //return;
        }

        let reffiltereedArray = this.state.metersList.filter(meter => meter.reference === this.state.mpanmpr);

        if(reffiltereedArray.length > 0)
        {

            toast.error('Looks like we already have this meter active against your account. Plese verify before continuing', {
                position: toast.POSITION.TOP_CENTER,
                delay: 100
            });

            //return;
        }




        let myArr = [...this.state.meters]



        myArr.push({ id: Math.random(), utility: this.state.utility, mpanmpr: this.state.mpanmpr, meterserial: this.state.meterserial, supplierName: this.state.supplierName, openingMeterReads: this.state.openingMeterReads })
        this.setState({
            meters: myArr
        })



        this.setState({
            [name]: value
        });


        this.setState({
            utility :   '',
            mpanmpr : '',
            meterserial: '',
            supplierName : '',
            openingMeterReads : ''
        })
    }
    };

    handleBillingChangeOption = (event, data) => {

        
        if(data.value === "other")
        {
        this.setState({
            newBillingAddress:''
        });
    }else if( data.value === "directToSite")
    {
        this.setState({
            newBillingAddress : 'Direct To Site'
         });

    }else //MoveOut
    {
        this.setState({
            newBillingAddress:'Send to Inenco'
         });
    }


        this.setState({
            [data.name]: data.value
        });

    }




    validateForm = () => {


           if(this.state.cotsAccess === "supplierCots")
    {        
     
        return this.state.changeDate !== '' 
            && this.state.siteAddress.length > 0 
            && this.state.meterAddress.length > 0 
            &&  (this.state.customerId !== "4799" || this.state.newBillingAddress.length > 0) 
            && this.state.previousOccupierName.length > 0 
            && this.state.previousOccupierContact.length > 0 
           // && (this.state.customerId === "4799" || this.state.supplierName.length > 0)
            //&& this.state.openingMeterReads.length > 0
            //&& (this.state.customerId === "4799" || this.state.mpanmpr.length > 0)
            && this.state.meters.length > 0
            //&& this.state.meterserial.length > 0
            && (this.state.customerId !== "4799" || this.state.entityEstateCode.length > 0);

    }else
    {
        
        return this.state.changeDate !== '' 
        && this.state.siteAddress.length > 0 
        && this.state.meterAddress.length > 0 
        && this.state.newBillingAddress.length > 0 
        && this.state.meters.length > 0
    }



    
    
        }

        manditoryLabel = (fieldName) => {
            if (this.state.cotsAccess === "supplierCots") {
                switch(fieldName) {
                    case 'changeDate':
                    case 'siteAddress':
                    case 'meterAddress':
                    case 'meters':
                    case 'previousOccupierName':
                    case 'previousOccupierContact':
                        return '*'
                    case 'billingOptions':
                        return this.state.customerId !== "4799" ? '*' : '';
                    case 'entityEstateCode':
                        return this.state.customerId === "4799" ? '*' : '';
                    case 'openingMeterReads':
                    case 'meterserial':
                    case 'utility':
                        return this.state.customerId === "4799" ? '*' : '';
                       

                    default:
                        return '';
                }
            } else {
                switch(fieldName) {
                    case 'changeDate':
                        case 'siteAddress':
                        case 'meterAddress':
                        case 'meters':
                        case 'newBillingAddress':
                            return '*'
                        default:
                            return '';
                }
            }
        }


        validateFormForSave = () => {

        
     
            return this.state.changeDate !== '' 
            && this.state.siteAddress.length > 0 
    
        }

        

        handleDocsModal = () => {  
            
                     
            if(this.state.billingOptions === 'otherBilling'  && this.validateAddressDetails(this.state.newBillingAddress) !== "Valid")
            {
                toast.error('Please check value for where your bills should be sent ' +  this.validateAddressDetails(this.state.newBillingAddress), {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50
                });
                return;
            }else if(this.validateAddressDetails(this.state.previousOccupierName) !== "Valid" && this.state.cotsAccess === "supplierCots")
            {
                toast.error('Please check previous ouccupier name is valid ' +  this.validateAddressDetails(this.state.previousOccupierName), {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50
                });
                return;
            }else if(this.validateAddressDetails(this.state.previousOccupierContact) !== "Valid"  && this.state.cotsAccess === "supplierCots")
            {
                toast.error('Please check previous ouccupier contact is valid ' +  this.validateAddressDetails(this.state.previousOccupierContact), {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50
                });
                return;
            }else
            {

            this.setState({showSiteDocsWarning:!this.state.showSiteDocsWarning})  
            }
        }  

        validateAddressDetails(str)
        {
            str = str.toLowerCase().trim();

            // List of invalid inputs
            const invalidInputs = ["tbc", "unknown", "n/a", "don't know", "...", "???", "none", "null", "empty"];

            // Check for invalid inputs
            if (invalidInputs.includes(str)) {
                return "Invalid input, please provide a valid answer.";
            }

            // Check length of the string
            if (str.length < 3) {
                return "Address must be at least 3 characters in length.";
            }
            
            return "Valid";
        }



        handlePauseCotRequest  = (event) => {


            if(this.state.submittingInProgress)
            {
                this.notify("Saving in progress please wait", true);
            }
    
            this.setState({
                    submittingInProgress: true,
            });

            var fileListOut = this.state.fileList.concat(this.state.prevFileList)
    
            const formData = new FormData();
            formData.append("siteAddress", this.state.siteAddress);
            formData.append("meterAddress", this.state.meterAddress);
            formData.append("changeDate", this.state.actualChangeDate);
            formData.append("newBillingAddress", this.state.newBillingAddress);
            formData.append("previousOccupierName", this.state.previousOccupierName);
            formData.append("previousOccupierContact", this.state.previousOccupierContact);
            formData.append("metersString", JSON.stringify(this.state.meters));
            formData.append("fileString", JSON.stringify(fileListOut));
            formData.append("customerId", authService.getUserData(AuthService.CUSTOMER_ID_KEY));
            



            if(this.state.params.queue !== undefined)
            {
            formData.append("previousQueueId", this.state.params.queue);
            }
    
            // try {
            api.postPauseCotRequest(formData)
                .then(verifyRes => {
    
                  
    
                    if (verifyRes.success) {
    
                        authService.addCotQueueItem(verifyRes.id,"New","New Site",this.state.siteAddress,this.state.params.queue,this.state.actualChangeDate)


                        if(this.state.params.queue !== undefined)
                        {
                        authService.removeCotQueueItem(this.state.params.queue,"New").then( () =>
                        {})
                        }


                        this.setState({
                            open: false,
                            submittingInProgress: false,
                            siteAddress:"",
                            entityEstateCode:"",
                            meterAddress:"",
                            actualChangeDate:"",
                            newBillingAddress:"",
                            previousOccupierName:"",
                            previousOccupierContact:"",
                            meters:[],
                            fileList:[],
                            allowSubmit: false
                        });
                        //this.setOpen(false)
                        //this.notify("Successfully Saved and Paused: your ref ID is " + verifyRes.id,false,true);
                        this.setOpenClearHistory(verifyRes.id, "true");
                        //window.location.reload();

                    } else {
    
    
                        this.setState({
                            open: false,
                            submittingInProgress: false
                        });
                        this.notify("Error submitting - contact IT Helpdesk", true);
    
                    }
    
                })
                .catch((error) => {
                    this.setState({
                        open: false,
                    });
                    this.notify("Unhandled Error - contact IT Helpdesk", true);
                });
        }


    handleAddCotRequest = (event) => {


        if(this.state.submittingInProgress)
        {
            this.notify("Submission in progress please wait", true);
        }

        this.setState({
                submittingInProgress: true,
        });
        var fileListOut = this.state.fileList.concat(this.state.prevFileList)

        const formData = new FormData();
        formData.append("siteAddress", this.state.siteAddress);
        formData.append("meterAddress", this.state.meterAddress);
        formData.append("changeDate", this.state.actualChangeDate);
        formData.append("newBillingAddress", this.state.newBillingAddress);
        formData.append("previousOccupierName", this.state.previousOccupierName);
        formData.append("previousOccupierContact", this.state.previousOccupierContact);
        formData.append("metersString", JSON.stringify(this.state.meters));
        formData.append("fileString", JSON.stringify(fileListOut));
        formData.append("customerId", authService.getUserData(AuthService.CUSTOMER_ID_KEY));
        formData.append("entityEstateCode", this.state.entityEstateCode);


        if(this.state.params.queue !== undefined)
        {
        formData.append("previousQueueId", this.state.params.queue);
        }

        // try {
        api.postAddCotRequest(formData)
            .then(verifyRes => {


                if (verifyRes.success) {

                    if(this.state.params.queue !== undefined)
                    {
                    authService.removeCotQueueItem(this.state.params.queue,"New").then( () =>
                    {})
                    }

                    this.setState({
                        open: false,
                        submittingInProgress: false,
                        siteAddress:"",
                        meterAddress:"",
                        entityEstateCode:"",
                        actualChangeDate:"",
                        newBillingAddress:"",
                        previousOccupierName:"",
                        previousOccupierContact:"",
                        meters:[],
                        fileList:[],
                        allowSubmit: false
                    });
                    //this.setOpen(false)
                    //this.notify("Successfully submitted: your case ID is " + verifyRes.id);
                    this.setOpenClearHistory(verifyRes.id, "false");

                } else {


                    this.setState({
                        open: false,
                        submittingInProgress: false
                    });
                    this.notify("Error submitting - contact IT Helpdesk", true);

                }

            })
            .catch((error) => {
                this.setState({
                    open: false,
                });
                this.notify("Unhandled Error - contact IT Helpdesk", true);
            });
    }

    render() {


        const billingOptions = [
            { key: 'directToSite', value: 'direct To Site', text: 'Direct To Site' },
            { key: 'inenco', value: 'Inenco', text: 'Inenco' },
            { key: 'otherBilling', value: 'otherBilling', text: 'Other' },
        ]

        const utilityOptions = [
            { key: 'elec', value: 'elec', text: 'Electricity' },
            { key: 'gas', value: 'gas', text: 'Gas' },
            { key: 'water', value: 'water', text: 'Water' }
        ]

        const CustomInput = ({ value, onClick }) => (
            <Input fluidvalue={value} value={value} onClick={onClick} icon="calendar" />
        );

        return (

            <Button.Group compact floated='right'>

                <Modal size="small"
                
                    trigger={ <Button floated='right' id='upload-meters'>
                    {this.state.customerId === "4799" ? 'New Acquisition' : 'Add New Site'}
                </Button>}
                    onOpen={() => this.setOpen(true)}
                    open={this.state.meterModalOpen}
                >
                    <Modal.Header>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2>Request new site</h2>
                        {this.state.cotsAccess === "supplierCots" ?
                                     
                                <HelpSection topic='NewSite' />
                                :
                                <HelpSection topic='NewSiteNonSupplier' />
                        }
                             </div>
                    </Modal.Header>
                    <Modal.Content>
                        <div>
                            <Segment>

                                <Dimmer active={this.state.submittingInProgress}>
                                <Loader>Submitting. Note* If you have submitted a lot of meters or files this may take a short time. Please remain on the page to recieve your reference number</Loader>
                                </Dimmer>

                                <Grid.Column>


                                    <Header as='h2'>Site Details</Header>

                                    <Popup content='This is the main address of the property, e.g. Focus House, High Street, London' trigger={<Input
                                        fluid placeholder={'Site Address' + this.manditoryLabel("siteAddress")} name="siteAddress" value={this.state.siteAddress} onChange={this.handleChange} />}></Popup><br />

                    <Checkbox  onChange={this.handleCopyAddress} label='Meter address same as the site address?'></Checkbox>

                                    <Popup content='This is where the meter supplies, e.g. 3rd floor Focus House, High Street, London' trigger={
                                
                                    <Input
                                        fluid placeholder={'Meter Address' + this.manditoryLabel("meterAddress")} name="meterAddress" value={this.state.meterAddress} onChange={this.handleChange} />}></Popup><br />

                                    {this.state.customerId === "4799" && (
                                        <>
                                            <Popup content='Please enter your entity estate code here' trigger={
                                                <Input
                                                    fluid 
                                                    placeholder={'Entity Estate Code'  + this.manditoryLabel("entityEstateCode")}
                                                    name="entityEstateCode" 
                                                    value={this.state.entityEstateCode} 
                                                    onChange={this.handleChange} 
                                                />
                                            } />
                                            <br />
                                        </>
                                    )}

                                    <Header as='h4'>{"Effective from" + this.manditoryLabel("changeDate")}</Header>   

                                    <Popup content='Date at which you became responsible for the utilities at this site.' trigger={

                                        <DatePicker selected={this.state.changeDate} locale="en-GB" dateFormat="dd/MM/yyyy" value={this.state.changeDate} onChange={this.handleDateChange} customInput={<CustomInput />} />

                                    }>

                                    </Popup><br /><br />
                                    
                                    <Dropdown
                          fluid
                          selection
                          placeholder={"Where should the bills be sent?" + this.manditoryLabel("billingOptions")} 
                          options={billingOptions}
                          value={this.state.billingOptions}
                          name="billingOptions"
                          onChange={this.handleBillingChangeOption}
                        />

                        {this.state.billingOptions === 'otherBilling' && <>
                                    <Popup content='Where should future bills be addressed to. Please note that if you take original invoice validation this should be in the format [Customer Name], C/O Inenco, Ribble House, Lytham FY8 4TS' trigger={<Input
                                        fluid placeholder='New Billing address' name="newBillingAddress" value={this.state.newBillingAddress}  onChange={this.handleChange} />}></Popup><br /><br /> </>}

                                        
                                        {this.state.cotsAccess === "supplierCots" && 
                                     <>
                                                <Popup content='Who was responsible for the property before the COT date' trigger={<Input
                                                    fluid placeholder={'Previous Occupier Name'+ this.manditoryLabel("previousOccupierName")} name="previousOccupierName" value={this.state.previousOccupierName} onChange={this.handleChange} />}></Popup><br /><br />

                                                <Popup content='Contact details for the previous occupier.' trigger={<Input
                                                    fluid placeholder={'Previous Occupier Contact Details'+ this.manditoryLabel("previousOccupierContact")} name="previousOccupierContact" value={this.state.previousOccupierContact}  onChange={this.handleChange} />}></Popup>
                                        </> }

                                    <Header as='h2'>{"Meters" + this.manditoryLabel("meters")}</Header>

                                    

                                    <Grid columns={2}>
                                        <Grid.Column>

                                            <Select fluid placeholder={'Select Utility'+ this.manditoryLabel("utility")} value={this.state.utility} name="utility" options={utilityOptions} onChange={this.handleDropDownChange} />
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Popup content='This will be located on the bills, and should be provided to you by the outgoing party' trigger={<Input
                                                fluid
                                                placeholder='MPAN/MPR'
                                                name="mpanmpr"
                                                onChange={this.handleChange}
                                                value={this.state.mpanmpr}

                                                />}>

                                            </Popup>
                                        </Grid.Column>
                                        <Grid.Column>

                                    <Popup content='This will be located on the bills, and should be provided to you by the outgoing party' trigger={<Input
                                        fluid
                                        placeholder={'Meter Serial Number'+ this.manditoryLabel("meterserial")}
                                        name="meterserial"
                                        onChange={this.handleChange}
                                        value={this.state.meterserial}

                                        />}>

                                    </Popup>
                                    </Grid.Column>
                                        <Grid.Column>

                                            <Popup content='If known, please confirm the current supplier' trigger={<Input
                                                fluid
                                                placeholder='Supplier Name'
                                                name="supplierName"
                                                onChange={this.handleChange}
                                                value={this.state.supplierName}

                                            />}></Popup>

                                        </Grid.Column>
                                        <Grid.Column>

                                            <Popup content='If you are unable to provide these your supplier will estimate the opening read, which may result in over or undercharges' trigger={<Input
                                                fluid
                                                placeholder={'Opening Meter Reads'+ this.manditoryLabel("openingMeterReads")}
                                                name="openingMeterReads"
                                                onChange={this.handleChange}
                                                value={this.state.openingMeterReads}

                                            />}></Popup>
                                        </Grid.Column>
                                    </Grid>
                                    <Button
                                        compact
                                        id='confirm-user'
                                        onClick={this.handleAddMeter}
                                    >Add Meter</Button>

                                    <div className="repeater-body">
                                        {this.state.meters.map((x,index) =>
                                            <Segment key={index} className='repeater-row'>
                                                
                                                    {x.mpanmpr + " - " + x.meterserial + " - " + x.utility + " - " + x.supplierName + " - " + x.openingMeterReads + " "}   
                                                    <Button
                                                        negative
                                                        floated='right'
                                                        vertical
                                                        compact
                                                        size='small'
                                                        id={x.id}
                                                        onClick={this.handleRemoveMeter}
                                                    >Remove</Button>
                                                



                                            </Segment>
                                        )}
                                    </div>
                                </Grid.Column>
                                
                                <Grid.Column>

                                {this.state.cotsAccess === "supplierCots" ?
                                     
                                    <Header as='h2'>Supporting Documents</Header> :
                                    <Header as='h2'>Meter Read Photos</Header> }
                                    <FilePond onupdatefiles={this.onFilesUpdated}  maxFileSize="7MB" labelMaxFileSizeExceeded="File is too Large" labelMaxFileSize="Maximum file size is {filesize}" allowMultiple={true} allowRevert={false} allowRemove={false} 
                                    allowProcess={false} 
                                    acceptedFileTypes={[
                                        'image/jpeg',
                                        'image/png',
                                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                                        'application/vnd.ms-excel', // .xls
                                        'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                                        'application/msword', // .doc
                                        'application/pdf', // .pdf
                                        'text/csv', // .csv
                                        'image/tiff' // .tif
                                    ]}server={{
                                        process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
                                            this.setState({ showInfoHide: true })
                                            const formData = new FormData();


                                           
                                            formData.append(fieldName, file, file.name);
                                            formData.append("client", authService.getUserData(AuthService.CUSTOMER_ID_KEY));
                                            formData.append("uploadedBy", authService.getUserData(AuthService.EMAIL_KEY));
                                            const request = new XMLHttpRequest();

                                            //request.open('POST', `${apiUrl}/MeterReads/something/${authService.getUserData(AuthService.CUSTOMER_ID_KEY)}`);
                                            request.open('POST', `${apiUrl}/Documents/PublishPrivateDocument`);

                                            request.setRequestHeader(
                                                'Authorization', `bearer ${localStorage.getItem("token")}`);

                                            request.upload.onprogress = (e) => {
                                                try
                                                {
                                                progress(e.lengthComputable, e.loaded, e.total);
                                                }catch
                                                {
                                                 
                                                    error("Failed please check file size")
                                                }

                                            };

                                            request.onerror = (e) =>
                                            {
                                               
                                                error("Failed please check file size")
                                            }

                                            request.onload = (e) => {

                                                var obj = JSON.parse(e.srcElement.response);



                                                if (request.status >= 200 && request.status < 300) {

                                                    if (obj.hasErrors) {


                                                        error("Failed")


                                                    } else {


                                                        let myArr = [...this.state.fileList]
                                                         myArr.push(obj.fileId)
                                                        this.setState({
                                                            fileList: myArr
                                                        })

                                                        load("Success");
                                                    }

                                                }
                                                else {


                                                    error('failed upload please check the file format.');
                                                }
                                            };


                                            request.send(formData);

                                            return {

                                                abort: () => {
                                                    request.abort();
                                                    abort();
                                                }
                                            };
                                        }
                                    }} />
                                </Grid.Column>
                                {this.state.prevFileList.length > 0 &&
                                <Grid.Column>
                                <Header as='h3'>Documents Uploaded Already</Header>

                                {this.state.prevFileNames.map((x,index )=>
                                            <Segment key={index} inverted  color='green' secondary className='repeater-row'>
                                              <Icon.Group floated="right" size='medium'>
                                                <Icon name='check' />
                                            </Icon.Group> <label> {x} </label> 

                                            </Segment>
                                        )}

                                </Grid.Column>
                                
                                }


                            </Segment>
                        </div>

                    </Modal.Content>
                    <Modal.Actions>
                    <Button   disabled={!this.validateFormForSave()}
                    
                    onClick={()=>this.handlePauseCotRequest()}>Save and Continue Later</Button>  

                    
{/* Conditional tooltip for the Continue button */}
{this.validateForm()
        ? <Button
            compact
            id='confirm-user'
            onClick={this.handleDocsModal}
          >
            Continue
          </Button>
        : <Popup
            content="Please check all details have been filled in and meters submitted with add meter"
            trigger={
              <span>
                <Button
                  compact
                  id='confirm-user'
                  disabled
                >
                  Continue
                </Button>
              </span>
            }
          />
    }

                            <Button 
                            compact
                            color='black' 
                            onClick={() => this.setOpen(false)}>
                                Dismiss
                            </Button>

                    </Modal.Actions>
                </Modal>

                <Modal open={this.state.showSiteDocsWarning} onHide={()=>this.handleDocsModal()}>
                

<Dimmer active={this.state.submittingInProgress}>
<Loader>Submitting. Note* If you have submitted a lot of meters or files this may take a short time. Please remain on the page to recieve your reference number</Loader>
</Dimmer>  

{this.state.cotsAccess === "supplierCots" ?
<>
                    <Modal.Header closeButton>Have you checked the required documentation?</Modal.Header>  
                            <Modal.Content> <Modal.Description>

                            <Message warning attached='bottom'>
                                            <Icon name='warning' />
                                            Please ensure any required <b>lease agreement</b> has been attatched or there will be potential delays in processing the request
                                        </Message>
                                        <Message warning attached='bottom'>
                                            <Icon name='warning' />
                                            Please ensure meters being moved out have had the <b>latest meter read photos</b> attatched or there will be potential delays in processing the request
                                        </Message>
                                        <Checkbox  onChange={this.handleChangeChk} label='I confirm I have read the above and have attatched the documents required or accept the processing delay'></Checkbox>
                                       </Modal.Description></Modal.Content>  
                                       </> :
                                       <>

                                       <Modal.Header closeButton>Have you provided all information required?</Modal.Header>  
                            <Modal.Content> <Modal.Description>

                            <Message warning attached='bottom'>
                                            <Icon name='warning' />
                                            Please ensure all details you have provided are accurate and correct
                                                                                                                                </Message>
                                                                                    <Message warning attached='bottom'>
                                            <Icon name='warning' />
                                            Please ensure meter read photos have been attached
                                                                                                                                </Message>
                                                                                    <Message warning attached='bottom'>
                                            <Icon name='warning' />
                                            Inenco will not contact the suppliers in relation to this change. If you would like our support with this, please speak to your Account Manager about our Change of Tenancy services
                                                                                                                                </Message>
                                        
                                        <Checkbox  onChange={this.handleChangeChk} label='I confirm I have read the above and have attatched the documents required or accept the processing delay'></Checkbox>
                                       </Modal.Description></Modal.Content>  
                                       
                                       </>}
                <Modal.Actions> 
                <Button onClick={()=>this.handleDocsModal()}>Cancel</Button>   
                <Button onClick={()=>this.handlePauseCotRequest()}>Save and Continue Later</Button>  
                <Button positive disabled={this.state.allowSubmit} onClick={()=>this.handleAddCotRequest()}>Submit Request</Button>  
          
                  
                </Modal.Actions>  
               
                </Modal>  

            </Button.Group>


        )
    }
}

export default withRouter(AddSiteModel);

